"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bounds = void 0;
var Bounds = /** @class */ (function () {
    function Bounds() {
    }
    Bounds.simplifyBounds = function (googleBounds) {
        var northEast = googleBounds.getNorthEast();
        var southWest = googleBounds.getSouthWest();
        var northEastLat = northEast.lat();
        var northEastLng = northEast.lng();
        var southWestLat = southWest.lat();
        var southWestLng = southWest.lng();
        return {
            tr: {
                lat: northEastLat,
                lng: northEastLng,
            },
            bl: {
                lat: southWestLat,
                lng: southWestLng,
            },
            tl: {
                lat: northEastLat,
                lng: southWestLng,
            },
            br: {
                lat: southWestLat,
                lng: northEastLng,
            },
        };
    };
    Bounds.latLonDistance = function (posA, posB) {
        var precision = 0.017453292519943295;
        var distance = 0.5 - Math.cos((posB.lat - posA.lat) * precision) / 2 + Math.cos(posA.lat * precision) * Math.cos(posB.lat * precision) * (1 - Math.cos((posB.lng - posA.lng) * precision)) / 2;
        return 12742 * Math.asin(Math.sqrt(distance));
    };
    return Bounds;
}());
exports.Bounds = Bounds;
//# sourceMappingURL=bounds.js.map